/** COMPONENTS **/
document.addEventListener('alpine:init', () => {
    window.Alpine.data('eventOverviewComponent', (data) => ({
        category: '',
        allEvents: {},
        filteredEvents: {},
        chosenCategories: [],
        allCategories: JSON.parse(JSON.stringify(data.allCategories)),
        chosenTypes: [],
        allTypes: JSON.parse(JSON.stringify(data.allTypes)),
        chosenLevels: [],
        allLevels: JSON.parse(JSON.stringify(data.allLevels)),
        loading: true,
        isColumnGrid: data.isColumnGrid ?? false,
        queryIds: data.queryIds ?? {},
        limit: data.limit ?? 0,
        changedFilterValues: {
            ['@multi-select-on-change.window'](event) {
                switch (event.detail.fieldName) {
                    case 'choose_category':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenCategories = this.allCategories;
                        } else {
                            this.chosenCategories = event.detail.values;
                        }
                        break;
                    case 'choose_type':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenTypes = this.allTypes;
                        } else {
                            this.chosenTypes = event.detail.values;
                        }
                        break;
                    case 'choose_level':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenLevels = this.allLevels;
                        } else {
                            this.chosenLevels = event.detail.values;
                        }
                        break;
                    default:
                        console.error('Unknown field name');
                }
                this.filterElements();
            },
        },
        init() {
            window.getRequest({
                params: {
                    action: '/bx-module/events/all-events',
                    isColumnGrid: this.isColumnGrid,
                    queryIds: JSON.stringify(this.queryIds),
                    limit: this.limit,
                },
            }).then((response) => {
                this.allEvents = JSON.parse(JSON.stringify(response.data.events));
                this.loading = false;
                if (Object.keys(this.allEvents).length) {
                    this.filteredEvents = this.allEvents;
                    this.chosenCategories = this.allCategories;
                    this.chosenTypes = this.allTypes;
                    this.chosenLevels = this.allLevels;
                }
            });
        },
        filterElements() {
            this.filteredEvents = this.allEvents
                .filter((item) => {
                    let foundInCategories = false;
                    let foundInTypes = false;
                    let foundInLevels = false;

                    Object.values(this.chosenCategories)
                        .forEach((value) => {
                            if (value == item.category) {
                                foundInCategories = true;
                            }
                    });

                    Object.values(this.chosenTypes)
                        .forEach((value) => {
                            if (value == item.type) {
                                foundInTypes = true;
                            }
                    });

                    /*
                        Here we need the key instead of the value.
                        That's what is saved in the cards.
                        Due to time constraints, we did not change the key in the cards.
                     */
                    Object.keys(this.chosenLevels)
                        .forEach((value) => {
                            if (value == item.level) {
                                foundInLevels = true;
                            }
                    });

                    if (foundInCategories && foundInTypes && foundInLevels) {
                        return item;
                    }
                })
        },
        resetFilters() {
            window.dispatchEvent(new CustomEvent('reset-categories', {
                detail: {
                    fieldName: 'choose_category',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-types', {
                detail: {
                    fieldName: 'choose_type',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-levels', {
                detail: {
                    fieldName: 'choose_level',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            this.chosenCategories = this.allCategories;
            this.chosenLevels = this.allLevels;
            this.chosenTypes = this.allTypes;
            this.filterElements();
        },
        compareObjects(filter, item) {
            for (let key in filter) {
                if (item.hasOwnProperty(key)) {
                    return true;
                }
            }
        }
    }));
});
